import React, { useEffect, useRef, useState } from "react";
import { postData } from "../../lib/utils";

const MAX_RETRY = 5;
const RETRY_DELAY = 3000;
const VIDEO_RETRY_DELAY = 4000;

const GalleryCard = ({ image, title,  onPlay, item }) => {
  const retryRef = useRef({});
  const [thumbStatus, setThumbStatus] = useState({});
  const imgRef = useRef(null);


    useEffect(() => {
    // ✅ Parent से Message Receive करना
    const handleMessage = (event) => {
    //  console.log("Message from Parent:", event.data);
      // ✅ Parent को Reply भेजना
     // event.source.postMessage("Hello from Iframe!", event.origin);
    };
  
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  // -------------------------------
  // CHECK VIDEO ON S3
  // -------------------------------
  const checkVideoOnS3 = async () => {
    const id = item._id;
    retryRef.current[id] = (retryRef.current[id] || 0) + 1;

    setThumbStatus((prev) => ({ ...prev, [id]: "checking-video" }));

    try {
      const res = await postData("products/check-file", {
        fileName: item.url,
      });

      if (res.exists) {
        retryRef.current[id] = 0;
        checkThumbnailOnS3();
      } else if (retryRef.current[id] < MAX_RETRY) {
        setTimeout(checkVideoOnS3, VIDEO_RETRY_DELAY);
      } else {
        setThumbStatus((prev) => ({ ...prev, [id]: "video-missing" }));
      }
    } catch (err) {
      console.error("Video check failed", err);
    }
  };

  // -------------------------------
  // CHECK THUMBNAIL ON S3
  // -------------------------------
  const checkThumbnailOnS3 = async () => {
    const id = item._id;
    retryRef.current[id] = (retryRef.current[id] || 0) + 1;

    setThumbStatus((prev) => ({ ...prev, [id]: "checking-thumb" }));

    try {
      const res = await postData("products/check-file", {
        fileName: item.thumbnail,
      });

      if (res.exists && imgRef.current) {
        imgRef.current.src = `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${item.thumbnail}`;
        setThumbStatus((prev) => ({ ...prev, [id]: "" }));
        retryRef.current[id] = 0;
      } else if (retryRef.current[id] < MAX_RETRY) {
        setTimeout(checkThumbnailOnS3, RETRY_DELAY);
      } else {
        setThumbStatus((prev) => ({ ...prev, [id]: "generate-thumb" }));
      }
    } catch (err) {
      console.error("Thumbnail check failed", err);
    }
  };

  // -------------------------------
  // IMAGE ERROR
  // -------------------------------
  const handleImageError = () => {
    if (!item?.url) return;
    checkVideoOnS3();
  };

  return (
    <div
      className="
        min-w-[260px] h-[200px] 
        relative rounded-[20px] overflow-hidden
        bg-[#f0eae1] border
        transform transition-transform hover:scale-105
        cursor-pointer flex-shrink-0
      "
        onClick={onPlay}
    >
      {/* Thumbnail */}
      <img
        ref={imgRef}
        src={`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${item.thumbnail}`}
        alt={title}
        className="w-full h-full object-cover"
        loading="lazy"
        onError={handleImageError}
      />

      {/* Overlay */}
      <div className="absolute inset-0 flex items-end p-3 bg-gradient-to-t from-black/70">
        <div>
          <div className="text-xs text-white font-semibold truncate">
            {title}
          </div>
        <div className="w-full ml-2 text-xs theme-link flex items-center cursor-pointer">
      <div className="mr-2">
        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="play" className="svg-inline--fa fa-play" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
          <path fill="currentColor" d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"></path>
        </svg>
      </div>
      <div>PLAY FILM</div>
    </div>
        </div>
          <div className="absolute top-0 right-0 left-0 bottom-0 flex items-center justify-center">
    <div className="text-4xl text-white opacity-60 center-play-ico">
      <img alt="play" loading="lazy" className='w-10 h-10' src="../../../img/video_icon.svg" />
    </div>
  </div>
      </div>

      {/* Debug Status (remove in prod) */}
      {thumbStatus[item._id] && (
        <div className="absolute top-2 left-2 text-[10px] text-white bg-black/60 p-2 py-0.5 rounded">
          {thumbStatus[item._id]}
        </div>
      )}
    </div>
  );
};

export default GalleryCard;
